export default function dataExportsReducer(state = {
  list: [],
  storage_name: '',
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_DATA_EXPORT_LIST_PENDING': {
      return {
        ...state,
        fetching: true,
        fetch: false
      };
    }
    case 'GET_DATA_EXPORT_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: action.payLoad.meta.exports,
        storage_name: action.payLoad.meta.storage_name
      };
    }
    case 'GET_DATA_EXPORT_LIST_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
      return {...state};
  }
}
